(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-rugby/assets/javascripts/status.js') >= 0) return;  svs.modules.push('/components/themes/sport-rugby/assets/javascripts/status.js'); "use strict";

(function (svs) {
  var logger = new svs.core.log.Logger('svs.themes.sport_rugby');
  svs = svs || {};
  svs.themes = svs.themes || {};
  svs.themes.sport_rugby = svs.themes.sport_rugby || {};

  svs.themes.sport_rugby.matchNotice = function (match) {
    if (!match) {
      logger.warn('Invalid parameter to matchNotice, returning empty string.');
      return '';
    }

    var matchStatus;

    switch (match.status) {
      case 16:
        matchStatus = 'Väntar på förlängning';
        break;

      case 18:
        matchStatus = 'Väntar på straffläggning';
        break;

      case 24:
        matchStatus = 'Försenad matchstart';
        break;

      case 25:
        matchStatus = 'Inställd';
        break;

      case 26:
        matchStatus = 'Avbruten';
        break;

      case 28:
        matchStatus = 'Stoppad av domare';
        break;

      default:
        matchStatus = '';
        break;
    }

    return matchStatus;
  };

  svs.themes.sport_rugby.isLive = function (status) {
    if (window.location.href.indexOf('isMocked') > -1) {
      return true;
    }

    return !!(_.contains([1, 2, 13, 14, 102, 103], status) || status >= 16 && status <= 22);
  };

  svs.themes.sport_rugby.isFinished = function (status) {
    return !!_.contains([31, 32, 33, 41, 104], status);
  };

  svs.themes.sport_rugby.isEnded = function (status) {
    return !!_.contains([25, 26, 28, 31, 32, 33, 41, 104], status);
  }; 


  svs.themes.sport_rugby.subscribeMatch = function (params) {
    return svs.themes.isDateHoursDiff(params.time, -5) && !svs.themes.sport_rugby.isEnded(params.status);
  };

  svs.themes.sport_rugby.hasStarted = function (status) {
    return status > 0 && !_.contains([23, 24, 25], status);
  };


  svs.themes.sport_rugby.isFullTimeOrPassed = function (status, options) {
    options = _.extend({
      includeFullTime: true,
      includePauses: true,
      includeFinished: true
    }, options);
    var statusesForOvertimeOrPenalties = [19, 20, 21, 22];

    if (options.includeFullTime) {
      statusesForOvertimeOrPenalties.push(31, 41);
    }

    if (options.includePauses) {
      statusesForOvertimeOrPenalties.push(16, 17, 18, 102);
    }

    if (options.includeFinished) {
      statusesForOvertimeOrPenalties.push(32, 33, 104);
    }

    return _.contains(statusesForOvertimeOrPenalties, status);
  };


  svs.themes.sport_rugby.getStatusText = function (options) {
    var text = '';
    options = _.defaults({}, options, {
      statusId: null,
      startTime: null,
      getStartTime: true
    });
    var status = options.statusId;

    if (svs.themes.sport_rugby.isLive(status)) {
      if (status === 1) {
        text = '1:A';
      } else if (status === 2) {
        text = '2:A';
      } else if (_.contains([19, 20, 21, 103], status)) {
        text = 'ÖT';
      } else if (status === 22) {
        text = 'STR';
      } else if (_.contains([14, 16, 17, 18, 102], status)) {
        text = 'PAUS';
      }

      if (!text) {
        text = '1:A';
      }
    } else if (svs.themes.sport_rugby.isEnded(status)) {
      if (_.contains([32, 104], status)) {
        text = 'ÖT';
      } else if (status === 33) {
        text = 'STR';
      } else if (status === 26) {
        text = 'AVBR';
      } else {
        text = 'FT';
      }
    } else if (options.startTime && options.getStartTime) {
      text = svs.themes.formatTime(options.startTime);
    }

    return text;
  };
})(svs);
 })(window);